import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { Constant } from '../constants/constant';
import { EcryptServiceService } from './ecrypt-service.service';
import { catchError, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ConfigServiceService {

  url = environment.serverAPI + '/api/catalog/siteData';

  url1 = environment.serverAPI4 + '/api/medical/delivery/site/data';

  url2 = environment.serverAPI4 + '/api/ig/medical/delivery/site/data';

  url6 = environment.serverAPI4 + '/' + 'api/product';

  url7 = environment.serverAPI4 + '/' + 'api/ig/product';
  constructor(private http: HttpClient,
	private ecryptService: EcryptServiceService,
	private userService: UserService) { }
	public responseCacheConfig = new Map();
  // getConfigData(): Observable<Object> {
	// 	return this.http.get(`${this.url}`);
	// }

  public getConfigData(): Observable<any> {

	   

	const configFromCache = this.responseCacheConfig.get(`${this.url}`);

	if (configFromCache) {
	  return of(configFromCache); // Return cached data as an Observable
	}
	
		const finalData = typeof window !== 'undefined' ? localStorage.getItem('m-d') : null;

		if (finalData) {
			// Defer expensive decryption + JSON.parse to the next macrotask so the
			// main thread isn't blocked during startup. Return an Observable that
			// emits the decrypted object when ready.
			return new Observable<any>((subscriber) => {
				setTimeout(() => {
					try {
						const decrypted = this.ecryptService.decryptionAES(finalData);
						const parsed = decrypted ? JSON.parse(decrypted) : null;

						if (parsed !== null) {
							this.responseCacheConfig.set(`${this.url}`, parsed);
							subscriber.next(parsed);
							subscriber.complete();
							return;
						}
					} catch (err) {
						console.error('Failed to decrypt/parse cached config:', err);
						// fallthrough to HTTP fetch below
					}

					// If parsing/decryption failed or produced null, fetch from server
					this.http.get<any>(`${this.url}`).pipe(
						catchError(error => {
							console.error('Error fetching configuration:', error);
							return of(null);
						}),
						tap(config => { if (config) this.responseCacheConfig.set(`${this.url}`, config); })
					).subscribe((cfg) => {
						subscriber.next(cfg);
						subscriber.complete();
					});
				}, 0);
			});
		}

		// Not present in localStorage; return HTTP Observable (and cache on success)
		return this.http.get<any>(`${this.url}`).pipe(
			catchError(error => {
				console.error('Error fetching configuration:', error);
				return of(null);
			}),
			tap(config => { if (config) this.responseCacheConfig.set(`${this.url}`, config); })
		);
	}

	public medicalDeliveryOption(): Observable<any> {
		let authourized = this.userService.getAuthenticatedUser();
		let guestLoginEnabled=localStorage.getItem(Constant['GUEST_LOGIN'])
			if (authourized==null||guestLoginEnabled=="1") {
				return this.http.get(`${this.url2}`);
	
			}else{
				return this.http.get(`${this.url1}`);
			}
	}

	deleteImage(data: any): Observable<Object> {
		let authourized = this.userService.getAuthenticatedUser();
		let guestLoginEnabled=localStorage.getItem(Constant['GUEST_LOGIN'])
			if (authourized==null||guestLoginEnabled=="1") {
				return this.http.post(`${this.url7}/deleteImage`, data);
			}else{
				return this.http.post(`${this.url6}/deleteImage`, data);
			}
	
	}
}
